import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconImg/wechat-pay.png'
import _imports_1 from '@/assets/iconImg/ali-pay.png'


const _withScopeId = n => (_pushScopeId("data-v-2526986e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提示：二维码有效期为2小时，过期必须重新生成 ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收款方式：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mr-10",
    src: _imports_0,
    style: {"height":"20px"},
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "微信")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mr-10",
    src: _imports_1,
    style: {"height":"16px","margin-left":"2px"},
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "支付宝")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "mt-20"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收款金额：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1711942667086",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4275",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M469.333333 682.666667v-85.333334H256v-85.333333h213.333333v-34.133333L264.533333 273.066667 328.533333 213.333333 512 396.8 695.466667 213.333333l59.733333 59.733334-200.533333 204.8v34.133333h213.333333v85.333333h-213.333333v85.333334h213.333333v85.333333h-213.333333v85.333333h-85.333334v-85.333333H256v-85.333333h213.333333z",
    fill: "#444444",
    "p-id": "4276"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 全额 ")
const _hoisted_9 = { class: "d-flex mt-20" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "收款备注：", -1))
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认生成")
const _hoisted_14 = { style: {"text-align":"center"} }
const _hoisted_15 = { style: {"font-size":"36px"} }
const _hoisted_16 = { class: "mt-10" }
const _hoisted_17 = { class: "position-relative" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "qr-dialog-qrcode",
  class: "qr-dialog-qrcode justify-content--center d-flex mt-30"
}, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "waring-icon"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"800"} }, "二维码已过期", -1))
const _hoisted_21 = {
  key: 0,
  class: "d-flex align-items-center justify-content--center mt-20"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-10",
  src: _imports_0,
  style: {"height":"40px"},
  alt: ""
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.5rem","color":"#9C9C9C"} }, "扫码支付", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "d-flex align-items-center justify-content--center mt-20"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-10",
  src: _imports_1,
  style: {"height":"36px","margin-left":"2px"},
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.5rem","color":"#9C9C9C"} }, "扫码支付", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-tips" }, "请扫码支付，长按无法识别", -1))

import {nextTick, reactive, ref, watch} from "vue";
import Api from "@/http/modules";
import {ElMessage, ElMessageBox} from "element-plus";
import dayjs from "dayjs";
import qrcodejs2 from 'qrcodejs2'
import {formatNumber, formatFullTime, getNumber} from '@/utils/index'
import {boolean, isNumber} from "mathjs";
import {isEmpty} from "element-plus/es/utils";


export default /*#__PURE__*/_defineComponent({
  props: {
    isShow: { type: Boolean },
    type: null,
    orders: null,
    order: null,
    qrInfo: null
  },
  emits: ['close', 'refresh'],
  setup(__props: any, { emit }) {

const props = __props as {
  isShow: boolean,
  //支付类型
  //order 单个订单生成二维码，传order
  //merge 多个订单合并收款 传orders
  //withoutOrder 无订单收款
  //showQr 直接显示二维码，isShow:false,传qrInfo
  type: 'order' | 'merge' | "withoutOrder" | 'showQr',
  orders: any[],
  order: any,
  qrInfo: any,
}

const {
  // 订单收款_获取收款二维码
  'POST/order/receipt/get_qr_code': get_qr_codeApi,
  // 订单收款_多订单合并收款_获取收款二维码
  'POST/order/receipt/get_qr_code_with_ids': get_qr_code_with_idsApi,
  //无订单收款
  'POST/order/receipt/get_qr_code_without_order': get_qr_code_without_orderApi
} = Api


const type_order = 'order';
const type_merge = 'merge';
const type_without_order = 'withoutOrder';
const type_show_qr = 'showQr';

const show = ref<boolean>(false)
const isShowCode = ref<boolean>(false)
const needRefresh = ref<boolean>(false)
const isCodeLoading = ref<boolean>(false)
let qrcodeEle: any = null

let codePayAmount = ref<number>(0)
let codeExpirationTime = ref<string>('')
let codePayType = ref<string>('')
watch(() => props.isShow, (n, o) => {
  if (n) {
    apiParams.paymentAmount = ''
    apiParams.payType = payTypeWeChat
    apiParams.note = ''
    show.value = true
  }
})

function showNewCode(code: string | null) {
  let node = document.getElementById("qr-dialog-qrcode");
  if (node) {
    clearQrCode()
    qrcodeEle = new qrcodejs2(node, {
      width: 180,
      height: 180,
    })

    if (code != null) {
      qrcodeEle.makeCode(code)
    }
  }
}

function clearQrCode() {

  let node = document.getElementById("qr-dialog-qrcode");
  if(node){
    node.innerHTML=''
  }
  // for (let j = 0; node && j < node.childNodes.length; j++) {
  //   node.removeChild(node.childNodes[0])
  // }
  // console.log("clearQrCode")
}


watch(() => props.qrInfo, (n, o) => {
  if (n.showQr) {

    show.value = false
    codePayType.value = (n.payType == payTypeWeChat || n.payType == '微信') ? payTypeWeChat : payTypeAlipay
    codePayAmount.value = n.paymentAmount
    codeExpirationTime.value = n.expirationTime
    nextTick(() => {
      // clearQrCode()
      showNewCode(n.code)
    })
    isShowCode.value = true
  }
})

watch(() => show.value, (n, o) => {
  if (!n && !isShowCode.value) {
    emitCloseEvent()
  }
})
watch(() => isShowCode.value, (n, o) => {
  if (!n && !show.value) {
    emitCloseEvent()
  }
  if (!n) {
    show.value = false;
    if (needRefresh.value) {
      emitRefreshEvent()
    }
    clearQrCode()
  }
})


watch(() => props.order, (n, o) => {
  if (n) {
    apiParams.id = n.id
    apiParams.orderName = n.name
    // calc balance
    if ((n.amount || n.amount >= 0) && (n.receivedAmount || n.receivedAmount >= 0)) {
      let amount = isNumber(n.amount) ? n.amount : parseFloat(n.amount)
      let receivedAmount = isNumber(n.receivedAmount) ? n.receivedAmount : parseFloat(n.receivedAmount)
      apiParams.calcAmont = (amount - receivedAmount).toFixed(2)
    }

  }
})

const apiParams: any = reactive({
  id: '',
  orderName: '',
  paymentAmount: '',
  calcAmont: 0,
  expirationTime: '',
  payType: '',
  note: ''
})


const calcAmount = () => {
  apiParams.paymentAmount = apiParams.calcAmont
}
const payTypeWeChat = "WECHAT";
const payTypeAlipay = "ALIPAY";

//


const get_qr_code = async () => {
  // Check if the variable is a number.
  if (Number.isNaN(apiParams.paymentAmount)) {
    ElMessage.warning('请输入正确数字')
    return
  }
  if (apiParams.paymentAmount <= 0) {
    ElMessage.warning('收款金额必须大于零')
    return
  }
  // 全额收款提示
  if (apiParams.paymentAmount == apiParams.calcAmont) {
    await ElMessageBox.alert('全额收款成功后将自动冲销订单（Closed） 多次收款后满足全额收款条件的也是一样的逻辑。', '提示')
  }
  // 打开二维码对话框
  codePayType.value = apiParams.payType
  codePayAmount.value = apiParams.paymentAmount
  isShowCode.value = true
  nextTick(() => {
    showNewCode(null)
    isCodeLoading.value = true
    get_qr_codeApi({
      id: apiParams.id,
      paymentAmount: apiParams.paymentAmount,
      orderName: apiParams.orderName,
      payType: apiParams.payType,
    }).then(({code_url}: any) => {
      // calc tiem
      codeExpirationTime.value = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')

      showNewCode(code_url)

      needRefresh.value = true
      // 关闭生成二维码对话框.
      show.value = false
    }).catch(() => {
      qrcodeEle.clear()
      isShowCode.value = false
    }).finally(() => {
      isCodeLoading.value = false
    })
  })
}
const get_qr_code_with_ids = async () => {
  const orders = props.orders
  if (orders.length < 2) {
    ElMessage.warning('合并收款请至少选择两个订单')
    return
  }
  let customerUsername = orders[0].customerUsername
  for (let i = 1; i < orders.length; i++) {
    if (orders[i].customerUsername != customerUsername) {
      ElMessage.warning('多个订单一起支付时，只能选择同一个客户的订单')
      return
    }
  }
  if (orders.filter((e: any) => e.amount == 0).length > 0) {
    await ElMessageBox.alert('请注意，勾选包含了金额为0的订单', '提示')
  }
  // 打开二维码对话框
  codePayType.value = apiParams.payType
  isShowCode.value = true
  // 自动求出差额(收款金额)
  codePayAmount.value = orders.reduce((total: number, e: any) => {
    return total += (Number(e.amount) - Number(e.receivedAmount))
  }, 0)
  nextTick(() => {
    showNewCode(null)
    isCodeLoading.value = true
    // 获取支付url生成二维码
    get_qr_code_with_idsApi({payType: apiParams.payType, ids: orders.map((e: any) => e.id)}).then(({code_url}: any) => {
      // 没有收款链接
      if (!code_url) {
        isShowCode.value = false
        return
      }
      needRefresh.value = true
      // 两小时后二维码过期
      codeExpirationTime.value = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
      showNewCode(code_url)
    }).catch((err: any) => {
      if (err.response.data) {
        ElMessage.error(err.response.data)
      }
      qrcodeEle.clear()
      isShowCode.value = false
    }).finally(() => {
      isCodeLoading.value = false
    })
  })
}
const get_qr_code_without_order = () => {
  if (Number.isNaN(apiParams.paymentAmount)) {
    ElMessage.warning('请输入正确数字')
    return
  }
  if (apiParams.paymentAmount <= 0) {
    ElMessage.warning('收款金额必须大于零')
    return
  }
  // 打开二维码对话框
  isShowCode.value = true
  // 自动求出差额(收款金额)
  codePayType.value = apiParams.payType
  codePayAmount.value = apiParams.paymentAmount

  nextTick(() => {

    showNewCode(null)
    isCodeLoading.value = true
    // 获取支付url生成二维码
    get_qr_code_without_orderApi({
      payType: apiParams.payType,
      note: apiParams.note,
      paymentAmount: apiParams.paymentAmount
    }).then(({code_url}: any) => {
      // 没有收款链接
      if (!code_url) {
        isShowCode.value = false
        return
      }
      needRefresh.value = true
      // 两小时后二维码过期
      codeExpirationTime.value = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
      showNewCode(code_url)
    }).catch((err: any) => {
      if (err.response.data) {
        ElMessage.error(err.response.data)
      }
      qrcodeEle.clear()
      isShowCode.value = false
    }).finally(() => {
      isCodeLoading.value = false
    })
  })

}
const generateCodeHandle = () => {
  if (props.type == type_order) {
    get_qr_code()
  } else if (props.type == type_merge) {
    get_qr_code_with_ids()
  } else {
    get_qr_code_without_order()
  }

}


const emitCloseEvent = () => {
  emit('close')
}
const emitRefreshEvent = () => {
  emit('refresh')
}



return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      title: "生成收款二维码"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (show.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (generateCodeHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_alert, {
            type: "warning",
            class: "mb-10",
            effect: "dark",
            closable: false
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(_component_el_radio_group, {
              id: "my-order-collection-radio-group",
              modelValue: _unref(apiParams).payType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(apiParams).payType) = $event)),
              class: "mt-20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: payTypeWeChat,
                  label: payTypeWeChat
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  value: payTypeAlipay,
                  label: payTypeAlipay
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (__props.type!==type_merge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_el_input, {
                  modelValue: _unref(apiParams).paymentAmount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(apiParams).paymentAmount) = $event)),
                  placeholder: "请输入收款金额",
                  style: {"width":"200px"},
                  maxlength: "12"
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (__props.type!==type_without_order)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "ml-10",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (calcAmount()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: "全额 = 金额 - 总计已收款金额",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { class: "ml-10" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_input, {
                modelValue: _unref(apiParams).note,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(apiParams).note) = $event)),
                type: "textarea",
                autosize: {minRows:2,maxRows:5},
                maxlength: 200
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowCode.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShowCode).value = $event)),
      title: "深圳火星语盟科技股份有限公司",
      center: "",
      "lock-scroll": "",
      "close-on-click-modal": false,
      "show-close": !isCodeLoading.value
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("h1", _hoisted_15, "￥" + _toDisplayString(_unref(getNumber)(_unref(codePayAmount))), 1),
          _createElementVNode("p", _hoisted_16, "二维码有效期为2小时(" + _toDisplayString(_unref(codeExpirationTime)) + "失效)，过期请联系客户经理", 1),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            (_unref(dayjs)()>_unref(dayjs)(_unref(codeExpirationTime)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_el_icon, {
                    color: "#F56C6C",
                    size: "100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WarningFilled)
                    ]),
                    _: 1
                  }),
                  _hoisted_20
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_unref(codePayType)===payTypeWeChat)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
            ])
          ])
        ])), [
          [_directive_loading, isCodeLoading.value]
        ]),
        _hoisted_29
      ]),
      _: 1
    }, 8, ["modelValue", "show-close"])
  ]))
}
}

})